import ProductCategoryHorizontalScroll from "./components/product-category-horizontal-scroll";
import FaqAccordion from "./components/faq-accordion";
import Quantity from "./components/quantity";
import FilterPriceSlider from "./components/filter-price-slider";
// import ElementorAccordion from "./components/elementor-accordion";
// import MobileTabs from "./components/mobile-tabs";
import InitSwiper from "./components/swiper";

document.addEventListener("DOMContentLoaded", function () {
    const lessContainer = document.querySelectorAll('.term-description.less, .meta-description.less');

    lessContainer.forEach( (item) => {
        item.addEventListener( 'click', () => {
            item.classList.remove('less');
        } )
    } )
});
